import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'user-cms',
    template: require('./user-cms.component.html')
})
export class UserCmsComponent {
    @Input() public cms: any;
    @Output() public onRemoveCms = new EventEmitter();
    @Output() public onTestCms = new EventEmitter<any>();
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/usersManagement/users/user-cms/user-cms.component.ts